import { useGLTF, useScroll } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useEffect, useRef } from "react";
import * as THREE from 'three';


type mousePosition = {
    x: number;
    y: number;
  };

type LogoNavModelType = {
    mousePosition: mousePosition;
  };

export function LogoNavModel(props: LogoNavModelType) {
  const groupRef = useRef<THREE.Group>(null);
  const { scene } = useGLTF('/models/Logo_W_4_nav.glb');

  useEffect(() => {
    if (groupRef.current) {
      // Bounding Box berechnen
      const box = new THREE.Box3().setFromObject(scene);
      const center = box.getCenter(new THREE.Vector3());
      // Modell auf Ursprung verschieben
      scene.position.sub(center);
    }
  }, [scene]);

  useFrame((state, delta) => {
    if (groupRef.current) {
      // Rotationsempfindlichkeit – passe diesen Wert an, bis der Effekt passt:
      const rotationFactor = 1.0;
      
      // Für die horizontale Rotation:
      // Globale Maus-x-Werte: in der rechten Hälfte: 0 bis 1,
      // wobei der Mittelpunkt der rechten Hälfte bei 0.5 liegt.
      // Nur wenn die Maus in der rechten Hälfte ist, berücksichtigen wir sie.
      const effectiveX = props.mousePosition.x ;
      
      // Für die vertikale Rotation:
      // Die globalen y-Werte sind bereits in [-1, 1] mit Mittelpunkt 0.
      // Hier kannst du auch einen Schwellwert oder Clamping hinzufügen, wenn nötig.
      const effectiveY = -props.mousePosition.y;
      
      // Interpolieren der Rotationswerte für einen weichen Effekt:
      groupRef.current.rotation.y += (effectiveX * rotationFactor - groupRef.current.rotation.y) * delta;
      groupRef.current.rotation.x += (effectiveY * rotationFactor - groupRef.current.rotation.x) * delta;
    }
  });


  return (
    <group ref={groupRef}>
      <primitive object={scene} />
    </group>
  );
};